import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fea6b56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "child-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Child component is orange", -1))




export default /*#__PURE__*/_defineComponent({
  emits: ["deleteText"],
  setup(__props, { emit }: { emit: ({
  (e: 'deleteText', message: string, divisor: number): void
}), expose: any, slots: any, attrs: any }) {

const message = "The child component lets you know that... "
const divisor = 3;



const deleteText = () => {
  emit('deleteText', message, divisor)
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("button", { onClick: deleteText }, "Delete all text")
  ]))
}
}

})